import { render } from "./PhysicianView.vue?vue&type=template&id=e6cd4272&scoped=true"
import script from "./PhysicianView.vue?vue&type=script&lang=ts"
export * from "./PhysicianView.vue?vue&type=script&lang=ts"

import "./PhysicianView.vue?vue&type=style&index=0&id=e6cd4272&lang=scss"
import "./PhysicianView.vue?vue&type=style&index=1&id=e6cd4272&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e6cd4272"

export default script